/**
 * Set the country.
 *
 * @return {object}
 */
var Country = function(country) {
    'use strict';

    var globals = {
        country: country
    };

    var elements = {
        'select': '.js-country',
        'items': '.js-country-items'
    };

    var events = [
        {
            element: elements.select,
            action: set,
            on: 'change'
        }
    ];

    /**
     * Call all functions for the country.
     */
    function init() {
        getCookie();
        listen();
        filter();
    }

    /**
     * Save the country in the cookie for 30 days.
     */
    function save() {
        Cookies.set('wp_countrycode', globals.country, { expires: 30 });
    }

    /**
     * Get the country from the cookie.
     */
    function getCookie() {
        var country = Cookies.get('wp_countrycode');

        if(country) {
            globals.country = country;
            $(elements.select).val(globals.country);
        }
    }

    /**
     * Run the event listeners.
     */
    function listen() {
        $.each(events, function() {
            $(this.element).on(this.on, this, this.action);
        });
    }

    /**
     * Set the country, when the country is changed in the dropdown.
     */
    function set(event) {
        globals.country = $(this).val();
        filter();
        $(event.data.element).not(this).val(globals.country);
    }

    /**
     * Hide all items except the items for the current country.
     */
    function filter() {
        $(document).trigger('way2web:country:unfilter');

        $(elements.items).find('div[data-country]').addClass('is-hidden');

        if(globals.country) {
            $(elements.items).find('div[data-country*=\'' + globals.country + '\']').removeClass('is-hidden');
            save();
        }

        /**
         * Set a trigger so Slick can be updated.
         */
        $(document).trigger('way2web:country:filter');
    }

    init();

    return {
        globals: globals,
        filter: filter
    };
};
